export const highlightMatches = (text: string, filter: string) => {
  const escapeRegExp = (string: string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  }

  if (!filter) return text
  const parts = text.split(new RegExp(`(${escapeRegExp(filter)})`, 'gi'))
  return parts.map((part, index) =>
    part.toLowerCase() === filter.toLowerCase() ? (
      <mark key={index}>{part}</mark>
    ) : (
      part
    ),
  )
}
